<template>
    <div class="pdp-page" id="pdp-page">
        <Head>
            <title>{{ pageTitle }}</title>
            <meta name="description" :content="product.meta_description" />
            <meta name="keywords" :content="product.keywords" />
        </Head>
        <div v-if="!expressOrderingDefaultOpen" class="breadcrumb-container">
            <!-- MOBILE -->
            <Link :href="route('category.shop-all', [lastCategory.seo_name])" v-if="lastCategory !== null && lastCategory.seo_name" class="breadcrumb desktop-hidden">
                <ArrowGreyIcon alt="arrow left" />
                <span class="paragraph-caption text-rothcoText">{{ lastCategory.category_name}}</span>
            </Link>
            <!-- DESKTOP -->
            <Link :href="route('home')" class="breadcrumb mobile-hidden">
                <span class="paragraph-caption text-rothcoText">Home</span>
                <ArrowGreyIcon class="arrow-right" alt="arrow right" />
            </Link>
            <Link as="div" :href="category.seo_name ? route('category.shop-all', [category.seo_name]) : route('404')" class="breadcrumb mobile-hidden" v-for="(category, index) of categories" :key="index">
                <span class="paragraph-caption text-rothcoText">{{ category.category_name }}</span>
                <ArrowGreyIcon v-if="index != categories.length -1" class="arrow-right" alt="arrow right" />
            </Link>
        </div>
        <div v-if="!expressOrderingDefaultOpen" class="pdp-container">
            <div class="pdp-main-content">
                <!-- IMAGE GALLERY -->
                <image-gallery-desktop :video-file="product.video_filename" :productImages="productImages" :download-images="downloadImages" :is-downloading-images="isDownloadingImages" :show-best-seller="product.best_seller && !showBelowTheFoldCta">
                    <shield-button v-if="showBelowTheFoldCta" class="fade-in-on-render" @click="scrollToProductInfo()" id="scroll-to-content-desktop" :type="belowTheFoldCta.style ?? 'primary'">
                        {{ belowTheFoldCta.label?.trim() ?? '' }}
                    </shield-button>
                </image-gallery-desktop>
                <!-- BUY STACK -->
                <div ref="buyStackRef">
                    <div class="productDetails">                    
                        <div class="productDetails-content-container">
                            <div class="productDetails-information">
                                <div id="product_name_header" class="headline-m headline">{{ props.product.item_name }}</div>
                                <div v-if="!hasPricingForProduct && is_dealer" class="productDetails-b2b-price">
                                   
                                    <span v-if="is_dealer" class="paragraph-feature">MAP: 
                                        <span class="productDetails-price-map title-l">
                                            ${{formatPrice(props.product.prices?.map_price)}}
                                        </span>
                                    </span>
                                    <div v-if="is_dealer" class="divider-horizontal"></div>
                                    <span v-if="is_dealer" class="paragraph-feature">MSRP: 
                                        <span class="productDetails-price-map title-l">
                                            ${{formatPrice(props.product.prices?.msrp_price)}}
                                        </span>
                                    </span>
                                    <div v-if="is_dealer && canSeePricing" class="divider-horizontal"></div>
                                    <span v-if="is_dealer && canSeePricing" class="paragraph-feature">Wholesale:
                                        <span class="productDetails-price-map title-l">
                                            ${{formatPrice(props.product?.default_wholesale_price)}}
                                        </span>
                                    </span>
                                </div>
                                <div v-else-if="!hasPricingForProduct && !is_dealer" clas="productDetails-price">
                                    <span v-if="!is_dealer" class="paragraph-feature">from&nbsp;</span>
                                    <span class="productDetails-price-total title-l">
                                        ${{formatPrice(props.product.prices?.msrp_price)}}
                                    </span>
                                </div>
                                <div v-else-if="is_dealer" class="productDetails-b2b-price">
                                    <span class="paragraph-feature">MAP: 
                                        <span class="productDetails-price-map title-l">
                                            {{productPricing?.map_price ? `$${formatPrice(productPricing?.map_price)}`: "N/A"}}
                                        </span>
                                    </span>
                                    <div class="divider-horizontal"></div>
                                    <span class="paragraph-feature">MSRP: 
                                        <span class="productDetails-price-map title-l">
                                            {{productPricing?.msrp_price ? `$${formatPrice(productPricing?.msrp_price)}`: "N/A"}}
                                        </span>
                                    </span>
                                    <div v-if="canSeePricing" class="divider-horizontal"></div>
                                    <span v-if="canSeePricing" class="paragraph-feature">Wholesale:
                                        <span class="productDetails-price-map title-l">
                                            {{productPricing?.price_to_use_with_discount ? `$${formatPrice(productPricing?.price_to_use_with_discount)}`: "N/A"}}
                                        </span>
                                        <span v-if="+productPricing?.original_price > +productPricing?.price_to_use_with_discount" class="productDetails-price-discount">
                                            ${{formatPrice(productPricing?.original_price)}}
                                        </span>
                                    </span>
                                </div>
                                <div v-else class="productDetails-price">
                                    <span class="paragraph-feature">from&nbsp;</span>
                                    <span class="productDetails-price-total title-l">${{formatPrice(productPricing?.price_to_use_with_discount)}}</span>
                                    <span v-if="+productPricing?.original_price > +productPricing?.price_to_use_with_discount" class="productDetails-price-discount">
                                        ${{formatPrice(productPricing?.original_price)}}
                                    </span>
                                </div>
                                <!-- <div v-if="!is_dealer" class="productDetails_coupons">
                                    <div v-for="(coupon,index) of relevantCoupons" :key="coupon.code" class="productDetails-discount_text paragraph-details">
                                        {{ `${coupon.description}: Code ${coupon.code}` }}<span class="divider" v-if="index < relevantCoupons.length-1">&nbsp;|&nbsp;</span>
                                    </div>
                                </div> -->
                                
                                <div class="productDetails-reviews">
                                    <div class="productDetails-reviews_item title-s">Item #{{itemNumber}}</div>
                                    <div class="productDetails-reviews_stars title-s">
                                        <YotpoWidget
                                            v-if="!itemComingSoon"
                                            :instance_id="yotpoStarsInstanceId"
                                            :widgetProps="{
                                                'product-id': props.product.item_index
                                            }"
                                            :html="props.product.yotpo_widgets.bottomline"/>
                                    </div>
                                </div>
                                <!-- TODO : BADGES -->
                                <!-- <div class="productDetails-badges ">
                                    <div class="productDetails-badge">
                                        <img alt="badge" class="badge-desktop" src="@icons/army-star-badge-icon.svg" />
                                        <p class="badge text-rothcoCharcoal">Army regulation</p>
                                    </div>
                                    <div class="productDetails-badge">
                                        <img alt="badge" class="badge-desktop" src="@icons/icon-concealed-carry.svg" />
                                        <p class="badge text-rothcoCharcoal">Concealed Carry</p>
                                    </div>
                                </div> -->
                            </div>
                            <!-- Mobile (IMAGE GALLERY)-->
                            <image-gallery-mobile ref="imageGalleryMobile" :productImages="productImages">
                                <RothcoCta
                                    v-if="showBelowTheFoldCta"
                                    :inertia="false"
                                    ctaType="button"
                                    id="scroll-to-content-mobile"
                                    :class="['small fade-in-on-render rotate-icon', (belowTheFoldCta.style ?? 'primary')]"
                                    button_icon="carret"
                                    @click="scrollToProductInfo()"
                                >
                                    <div>{{ belowTheFoldCta.label }}</div>
                                </RothcoCta>
                            </image-gallery-mobile>
                            <!-- Developer Notes: There are 3 hidden swatches, in order to prevent the previous 2 columns from stretching -->
                            <ProductSpecGroup
                                v-for="(specGroup, key) in buyStack"
                                :key="key"
                                :specGroup="specGroup"
                                :selectedVariantValues="selectedVariantValues"
                                :variationValueAvailablity="variationValueAvailablity"
                                :numSpecGroups="Object.keys(buyStack ?? {}).length"
                                @add-variation-value="addVariationValue($event)"
                            />
                            <div v-if="builderData?.relatedProductLink?.seoName" class="productDetails-additional_link">
                                <RothcoCta ctaType="a" class="paragraph-details pdp-only" :href="route('productDetail.show',  [builderData?.relatedProductLink?.seoName])">
                                    {{ builderData?.relatedProductLink?.label }}
                                </RothcoCta>
                            </div>
                            <div v-if="!inStock && !nextMissingVariant && (props.product.d2c_view_only == 0 || is_dealer )" :class="['productDetails-size_stock title-m', etaInfo.eta_color]">
                                {{ etaInfo.eta_message }}{{ etaInfo.eta_date ? " | ETA " + moment(etaInfo.eta_date).format("MM/DD/YY") : null }}
                            </div>
                            <div v-else class="productDetails-size_stock title-m text-inStockGreen">
                                <span v-if="is_dealer && canSeePricing">
                                    Your Price: ${{formatPrice(productPricing?.price_to_use_with_discount)}}
                                    <span style="margin-left:2rem;">{{+selectedVariant?.inventory_level >= 99 ? `99+` : +selectedVariant?.inventory_level }} available</span>
                                </span>
                                <span v-else-if="props.product.d2c_view_only == 0">In Stock & Ready to Ship</span>
                            </div>

                            <div class="productDetails-actions">
                            <number-input v-if="(props.product.d2c_view_only == 0 || is_dealer) && inStock" type="number" name="counter" id="quantity" class="productDetails-counter_input"  min="0" max="99999" step="1" v-model.natural.whole="quantity" @wheel.prevent="blurOnWheel" />
                                <RothcoCta v-if="props.product.d2c_view_only == 1 && !is_dealer" class="primary productDetails-order_btn" ctaType="button" :href="retailLocatorUrl" id="find_retailer_button">Find a Retailer near you</RothcoCta>
                                <button v-else-if="nextMissingVariant" type="submit" class="disabled productDetails-submit_btn">{{ `Please Select Your ${nextMissingVariant}` }}</button>
                                <RothcoCta 
                                    v-else-if="!nextMissingVariant && inStock"
                                    id="addToCartButton" ctaType="button" :disabled="quantity <= 0" preserve-scroll 
                                    :class="['productDetails-order_btn', (quantity > 0 && +totalPrice > 0) ? 'primary' : 'disabled']" @click="addToCart()">
                                        Add to Cart{{ canSeePricing ? ` - $${totalPrice}` : '' }}
                                </RothcoCta>
                                <RothcoCta v-else-if="!nextMissingVariant && !inStock && etaInfo.eta_date" :class="[(subscribedForInstockEmail ? 'disabled' : 'primary'), 'productDetails-order_btn']" ctaType="button" @click="openEmail(selectedVariant?.item_variation_id)" :disabled="subscribedForInstockEmail">
                                    {{ subscribedForInstockEmail ? 'Subscribed to In-stock Alerts' : (`Get Notified When It's ${etaInfo.out_of_stock ? "Back" : "Here"}`) }}
                                </RothcoCta>
                                <RothcoCta v-if="is_dealer" class="secondary productDetails-express_btn" ctaType="button" @click="openExpressOrdering()">Express Ordering</RothcoCta>
                            </div>

                            <!-- <div class="paragraph-details low-payment-wrapper">
                                <span class="low-payment">
                                    As low as 4 payments of $12.50/mo with BNPL.
                                </span> 
                                <a href="/" class="productDetails-color_link paragraph-details">Details</a>
                            </div> -->

                            <div class="productDetails-action_options">
                                <div class="productDetails-action" @click="addToCompareDeck()" tabindex="0">
                                    <CompareIcon alt="compare-icon" />
                                    <div class="title-xs product-options">Compare Products</div>
                                </div>
                                <div class="divider-horizontal"></div>
                                <div class="productDetails-action" tabindex="0" @click="toggleFavorite()">
                                    <FavoriteIcon v-show="hasFavorite" alt="favorite-icon" />
                                    <SaveFavoriteIcon v-show="!hasFavorite" alt="favorite-icon" />
                                    <div class="title-xs product-options">{{ hasFavorite ? 'Remove from ' : 'Save to ' }}Favorites</div>
                                </div>
                            </div>

                            <div class="paragraph-default productDetails-shipping_text">
                                <span v-if="is_dealer"><span class="ground-shipping">Rothco's Steadfast Service: &nbsp;</span><span class="see-details">24-hour Turnarounds & 99% In-stock Rate</span></span>
                                <span v-else>
                                    <span class="ground-shipping">{{ freeShippingAmount > 0 ? `Free ground shipping over $${freeShippingAmount}` : `Free ground shipping on all orders` }} :&nbsp;</span> 
                                    <a class="see-details" :href="route('index.cms', ['rothco-promotion-details'])" target="_blank" noopener>See Details</a></span>
                            </div>

                            <!-- TODO -->
                            <div v-if="upsellProduct.item_id" class="productDetails-product_card">
                                <div class="productDetails-product_card-details">
                                    <span class="product-image-wrapper">
                                        <img alt="product-cart" :src="resolveProductUploadDisplayUrl(upsellProduct.item_image, 'small')" />
                                    </span>
                                    <div class="productDetails-product_card-description">
                                        <p class="paragraph-deafult looks-great">Pairs Well With</p>
                                        <div class="title-m looks-great-sub-header">{{ upsellProduct.item_name }}</div>
                                        <div class="productDetails-product_card-price" v-if="!is_dealer">
                                            <span class="paragraph-caption">from</span><span class="title-xs price">${{ upsellProduct.item_price }}</span><span class="paragraph-details" v-if="upsellProduct.totalColors > 1">| {{ upsellProduct.totalColors }} Colors</span>
                                        </div>
                                        <div class="productDetails-product_card-price" v-else>
                                            <span class="paragraph-caption">View Item to See Your Pricing</span><span class="paragraph-details" v-if="upsellProduct.totalColors > 1">| {{ upsellProduct.totalColors }} Colors</span>
                                        </div>
                                        <a @click.prevent="toggleBuystackFlyout({seo_name: upsellProduct.seo_name})" class="primary productDetails-product_card-details_mobile">View Details</a>
                                    </div>
                                </div>
                                <div class="productDetails-product_card-details_desktop_container">
                                    <a @click.prevent="toggleBuystackFlyout({seo_name: upsellProduct.seo_name})" class="primary productDetails-product_card-details_desktop">View Details</a>
                                </div>
                            </div>

                            <!-- <div v-if="prop65Spec && prop65Spec.length > 0">
                                <SfButton style="background-color: red" @click="openP65"
                                    >Prop 65 Modal</SfButton
                                >
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section v-if="hasPricingForProduct" class="b2b-express-order">
            
            <express-ordering
                ref="expressOrderingGrid"
                :item_variations="itemVariations"
                :swatch_images="props.product.swatch_images"
                :productLineCode="props.product.product_line_code"
                :prices="pricing"
                :current-list-items="currentListItems"
                :current_list_id="current_list.list_id"
                v-model="express_ordering_open"
                :default_open="route().params.express == 1 && is_dealer"
                :source="expressOrderingSource"
                :ordering-info="props.express"
            >
            <div class="b2b-express-order__title-wrapper" style="padding-left: 0px;" v-if="is_dealer">
                <h1 class="headline-l">Express Order</h1>
                <p class="paragraph-feature" v-if="props.product.item_variations && route().params.express == 1">{{ props.product.item_variations.length }} Results for <strong>"{{ props.product.item_name }}"</strong></p>
            </div>
            </express-ordering>
        </section>
        <section v-else-if="!hasPricingForProduct && is_dealer" class="b2b-express-order">
            <div class="b2b-express-order__title-wrapper" v-if="is_dealer">
                <h1 class="headline-l">Express Order</h1>
                <p class="paragraph-feature" v-if="props.product.item_variations && route().params.express == 1">Loading {{ props.product.item_variations.length }} Results for <strong>"{{ props.product.item_name }}"</strong></p>
            </div>
            <div class="skeleton-container">
                <div class="pdp-skeleton skeleton"></div>    
            </div>
        </section>
        <ProductTabs v-show="route().params.express != 1" :features="tabContent.features" :feature-icons="tabContent.featureIcons" :description="tabContent.description" :specs="tabContent.specs" :spec_groups="props.product.spec_groups" :shipping_dimensions="props.product.shipping_dimensions" :spec_sheet="specsheetUrl" :prop65Spec="prop65Spec" />
        <Cms
         v-show="route().params.express != 1"
            ref="cms"
            model="pdp-content"
            :url="`/index/products/${props.product.seo_name}`"
            content-prop="productContent"
            driver="builder"
            :components="getBuilderComponents({include:[ subCategoryGridInit, subCategoryLaunchers ]})"
            :injected-data="{
                specs
            }"
            :search-params="searchParams"
            is-section
            :readableFields="['belowTheFoldCta','relatedProductLink']"
            v-model="builderData"
        />

        <ProductCarousel v-if="route().params.express != 1 && !pdpCmsHasBuilderContent" :heading="{
            text: customersAlsoBoughtCarousel 
        }" :boost-tag="['cross-sell']" allowQuickView/>
        <ProductCarousel v-if="route().params.express != 1 && !pdpCmsHasBuilderContent" :heading="{
            text: similarProductsCarousel
        }" :boost-tag="['similar']" allowQuickView/>
        <YotpoWidget
            :instance_id="yotpoQNAInstanceId"
            :widgetProps="{
                'product-id': props.product.item_index,
                'name': props.product.item_name,
                'url': pageUrl,
                'image-url': productImages?.[0]?.media ?? null,
                'price': productPricing?.price_to_use_with_discount,
                'description': props.product.description,
                'currency': 'USD'
            }"
            :html="props.product.yotpo_widgets.questionsBottomline"
        />
        <YotpoWidget
            v-if="!itemComingSoon"
            :instance_id="yotpoReviewsInstanceId" 
            :widgetProps="{
                'product-id': props.product.item_index,
                'name': props.product.item_name,
                'url': pageUrl,
                'image-url': productImages?.[0]?.media ?? null,
                'price': productPricing?.price_to_use_with_discount,
                'description': props.product.description,
                'currency': 'USD'
            }"
            :hmtl="props.product.yotpo_widgets.mainWidget"
        />
        <ProductCarousel v-if="route().params.express != 1 && hasRecentlyViewedProducts" :heading="{
            text: 'Recently Viewed'
        }" :boost-tag="['recently-viewed']" allowQuickView/>
        <PdpSticky
            :isVisible="pdpStickyVisible"
            :compareCount="store.products.length" 
            :product-name="props.product.item_name" 
            :originalPrice="productPricing?.original_price" 
            :discountPrice="productPricing?.price_to_use_with_discount" 
            @open-compare="addToCompareDeck"
            @select-options="openBuyStackFlyout"
        />
    </div>
</template>
<script setup lang="ts">
    import { computed, ref, onMounted, watchEffect, onBeforeUnmount, provide, watch, type PropType, inject } from "vue";
    import moment from "moment";
    import _ from "lodash";

    import ImageGalleryDesktop from "@/components/ProductImageGalleryDesktop.vue";
    import ImageGalleryMobile from "@/components/ProductImageGalleryMobile.vue"
    import RothcoCta from "@/components/RothcoCta.vue"
    import StarRating from "@/components/StarRating.vue";
    import Cms from "@/components/Cms.vue";
    import ProductCarousel from "@/components/ProductCarousel.vue";
    import { useLists } from "@/helpers/composables/useList";
    import { useElementVisibility } from "@vueuse/core";
    import { useCompareDeckStore } from "@/store/compareDeck.ts";
    import { type Product, useProductDetails } from "@/helpers/composables/useProductDetails";
    import { useSettingsStore } from "@/store/settings.ts";
    import { storeToRefs } from "pinia";
    // import { route } from "ziggy-js";
    
    import Prop65WarningModal from "@/components/Prop65WarningModal.vue";
    import ReceiveEmailModal from "@/components/ReceiveEmailModal.vue";
    import ProductReviews from "@/components/ProductReviews.vue";
    import ReviewModal from "@/components/ReviewModal.vue";
    import CartPreview from "@/components/cart/CartPreview.vue";
    import ProductSpecGroup from "@/components/ProductSpecGroup.vue";
    import ProductTabs from "@/components/ProductTabs.vue";
    import ExpressOrdering from "@/components/ExpressOrdering.vue";
    import ShieldButton from "@/components/ShieldButton.vue";
    import YotpoWidget from "@/components/YotpoWidget.vue";
    
    import { createUseFavoritesStore } from "@/store/favorites";
    // import { registeredComponents } from "../../product-detail-page-init-builder.ts";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { subCategoryGridInit } from "@/helpers/builder-init/SubCategoryGrid";
    import { subCategoryLaunchers } from "@/helpers/builder-init/SubCategoryLaunchers";
    import { router, Link, Head} from "@inertiajs/vue3";
    import { useProductDetailStore } from "@/store/productDetailStore";
    import { usePage } from "@inertiajs/vue3";
    import { useSearchSpringCookiesStore } from "@/store/searchSpringCookies.ts";
    import { useDialog } from 'primevue/usedialog';
    import { nextTick } from "vue";
    import { useBoost } from "@/helpers/composables/searchSpringApi";
    import PdpSticky from "@/components/PdpSticky.vue";
    import { useMetaConversionAPI } from "@/helpers/composables/useMetaConversionAPI";
    
    import he from "he";
    import { useGenericStore } from "@/store/genericStore";

    import ArrowGreyIcon from "@icons/arrow-grey.svg";
    import CompareIcon from "@icons/iconamoon_compare-light.svg";
    import FavoriteIcon from "@icons/favorite-icon-product-card.svg";
    import SaveFavoriteIcon from "@icons/icon-save-favorite-pdp.svg";
    import useGoogleManager from "@/helpers/composables/google";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
    import { productUploadImageUrl, resolveProductUploadDisplayUrl } from "@/helpers/productUploadImageUrl";
    import { useIntelliSuggest } from "@/helpers/composables/intellisuggest";
    import { useAttentive } from "@/helpers/composables/attentive";
    const dialog = useDialog();
    let route:Function = inject("route");
    let { addToList } = useLists({ router, route });

    const yotpoStarsInstanceId = import.meta.env.VITE_YOTPO_STARS_INSTANCE_ID
    const yotpoQNAInstanceId = import.meta.env.VITE_YOTPO_QNA_INSTANCE_ID
    const yotpoReviewsInstanceId = import.meta.env.VITE_YOTPO_REVIEWS_INSTANCE_ID;

    const pageUrl = computed(()=>{
        return typeof window !== 'undefined' ? window.location.href : '';
    })

    const pageTitle = computed(() => {
        const tag = props.product.title_tag?.trim();
        return tag || props.product.item_name;
    });

    let { metaProductView } = useMetaConversionAPI();
    let { attentiveProductView, attentiveAddToCart } = useAttentive();
    let props = defineProps({
        product: {
            type: Object as PropType<Product>,
            required: true,
            default() {
                return {
                    images: [],
                    item_variations: [],
                    item_specifications: []
                };
            }
        },
        prices: {
            type: Object,
            default() {
                return {};
            }
        },
        current_list: {
            type: Object,
            default() {
                return {};
            }
        },
        express: {
            type: Object,
            default() {
                return {
                    line_limit: 0,
                    contacts: {
                        email: "",
                        phone: ""
                    }
                };
            }
        },
        flash: {
            type: Object,
            default: ()=>{
                return {}
            }
        },
    });

    const buyStackFlyoutDataStore = useGenericStore("buyStackFlyoutDataStore");
    let {state: buyStackFlyoutDataState} = storeToRefs(buyStackFlyoutDataStore);
    buyStackFlyoutDataState.value = {};
    
    let uniqueFeatureIcons = computed(() => {
        let featureIcons = props.product.feature_icons ? Object.values(props.product?.feature_icons ?? {}) : [];
        let icons = new Set(featureIcons.map(f => f.icon));

        return [...icons].slice(0, 4).map(icon => {
            return { icon, text: featureIcons.find(f => f.icon == icon)?.caption };
        });
    });

    let tabContent = computed(()=>{
        const groupedSpecs = props.product.item_specifications.reduce((acc, spec) => {
            const groupName = spec.group?.spec_group_name;
            const specValue = spec.value?.spec_value;
            const specType = spec.group.spec_value_type;
            if (groupName && specValue) {
                const group = acc.find(g => g.group === groupName);
                if (group) {
                    group.values.push(specValue);
                } else {
                    acc.push({ group: groupName, type: specType, values: [specValue] });
                }
            }
            return acc;
        }, []);
        let formattedGroupedSpecs = groupedSpecs.map(spec=>{
            let data = spec.values.join(', ');
            let isHtml = /<\/?[a-z][\s\S]*>/i.test(data);
            return {
                header: spec.group,
                type: isHtml ? 'richText' : 'text',
                data,
            }
        });
        if(catalogPage.value){
            formattedGroupedSpecs?.push({
                header: "Catalog Page",
                type: 'text',
                data: catalogPage.value,
            })
        }
        if(msds.value){
            formattedGroupedSpecs?.push({
                header: "MSDS",
                type: 'richText',
                data: msds.value,
            })
        }
        return {
            description: props.product?.description ?? "",
            features: props.product.bullets ?? [],
            featureIcons: uniqueFeatureIcons.value ?? [],
            specs: formattedGroupedSpecs,
        };
    });

    let toCamelCase = (str) => {
        return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index == 0 ? word.toLowerCase() : word.toUpperCase();
            })
            .replace(/\s+/g, "");
    };
    let specs = computed(() => {
        return props.product.item_specifications.reduce((acc, spec) => {
            let groupName = toCamelCase(
                spec.group.spec_group_name,
                "camelCase"
            );
            if (!acc[groupName]) {
                acc[groupName] = {
                    name: spec.group.spec_group_name,
                    values: props.product.item_specifications
                        .filter(
                            (s) =>
                                s.group.spec_group_name ==
                                    spec.group.spec_group_name &&
                                s.value != null
                        )
                        .map((s) => s.value.spec_value)
                        .join(", ")
                };
            }
            return acc;
        }, {});
    });

    let isFromExpressOrderingCheckbox = computed(() => {
        return route().params.express == 1;
    });

    let specsheetUrl = computed(() => {
        return route('specsheet.generate', {
            seo_name: props.product.seo_name,
            variation_id: closestVariant.value.item_variation_id
        });
    });

    let expressOrderingSource = computed(() => {
        return isFromExpressOrderingCheckbox.value
            ? import.meta.env.VITE_EXPRESS_ORDERING_GRID_CHECKBOX_SOURCE
            : import.meta.env.VITE_EXPRESS_ORDERING_GRID_SOURCE;
    });
    
    const buyStackRef = ref(null);
    let buyStackIsVisible = ref(true);

    let pdpStickyVisible = computed(()=>{
        return !['',null,undefined].includes(productPricing?.value?.original_price) && !buyStackIsVisible.value && !express_ordering_open.value;
    });


    let hasRecentlyViewedProducts = computed(()=>{
        if(typeof window === 'undefined') return false;
        let viewedProducts = document.cookie.split('; ').find(row => row.startsWith('ssViewedProducts='));
        
        if(viewedProducts){
            return viewedProducts.split('=')[1].split(',').length > 0;
        }
        return false;


    });

    let {
        buyStack,
        quantity,
        productImages,
        productLargeImages,
        productPricing,
        totalPrice,
        selectedVariant,
        closestVariant,
        catalogPage,
        msds,
        addVariationValue,
        selectedVariantValues,
        nextMissingVariant,
        variationValueAvailablity,
        variationSpecs,
        primaryImage,
        prop65Spec,
        inStock,
        etaInfo,
        itemComingSoon,
        formatPrice,
        currentListItems,
        categories,
        lastCategory,
        downloadImages,
        isDownloadingImages,
        retailLocatorUrl,
        itemNumber,
        defaultItemNumber,
        itemVariations,
        getProductPricing,
        pricing,
        d2c_view_only,
        instockEmails,
        subscribedForInstockEmail,
        subscribeToInstockEmail,
        selectVariationValuesFromItemNumber
    } = useProductDetails({ product: props.product, route: route });

    let buyStackFlyoutVisible = ref(false);

    let hasPricingForProduct = computed(() =>
        pricing.value.find((price) =>{
            return props.product.item_variations.find((variation) => variation.item_variation_id == price.web_variation_id)
        }) != null
    );
    const buyStackFlyoutData = computed(()=>{
        return {
            selectedVariant,
            productPricing,
            productImages,
            productLargeImages,
            buyStack,
            selectedVariantValues,
            variationValueAvailablity,
            inStock,
            nextMissingVariant,
            etaInfo,
            quantity,
            totalPrice,
            addVariationValue,
            product: props.product,
            d2c_view_only,
            retailLocatorUrl,
            itemNumber,
            instockEmails,
            subscribedForInstockEmail,
            subscribeToInstockEmail,
            selectVariationValuesFromItemNumber
        }
    })
    buyStackFlyoutDataState.value = buyStackFlyoutData.value;

    let store = useCompareDeckStore();
    let { addProductToDeck, openCompareDeck } = store;

    const addToCompareDeck = ()=>{
        addProductToDeck({
            item_name: props.product.item_name,
            primary_image: primaryImage.value
                ? productUploadImageUrl(primaryImage.value, null)
                : comingSoonImages().small,
            selectedVariant: {...selectedVariant.value, 
                item: {
                    seo_name: props.product.seo_name, 
                    d2c_view_only: props.product.d2c_view_only,
                    market: props.product?.market?.market_id ?? 0
                },
            },
            pricing: productPricing.value,
            item_specifications: [
                ...props.product.item_specifications,
                ...variationSpecs.value
            ],
            swatch_images: props.product.swatch_images ?? {},
            product_line_code: props?.product?.product_line_code ?? null
        });

        openCompareDeck();
    }
    let openEmail = (variationId) => {
        if(subscribedForInstockEmail.value) return;
        if(!isLoggedIn.value){
            toggleFlyout({
                type: 'info',
                headline: 'Signing up for Instock Alerts? ',
                message: 'Please log in or create an account to subscribe.',
                afterLoginAction: ()=>{
                    subscribeToInstockEmail(variationId);
                },
                createAccountParams: {
                    instock_email: variationId
                }
            });
        }
        else{
            dialog.open(ReceiveEmailModal, {
                props: {
                    showHeader: false,
                    modal: true
                },
                data: {
                    itemVariationId: variationId ?? null,
                    beforeClose: (variationId)=>{
                        instockEmails.value[variationId] = 0;
                    }
                }
            });
        }
    };

    let openReview = () => {
        dialog.open(ReviewModal, {
            props: {
                showHeader: false,
                modal: true
            },
            data: {
                itemId: props.product.item_index,
                isModal: true,
            },
        });
    };


    let express_ordering_open = ref(false);
    let openExpressOrdering = function () {
        express_ordering_open.value = true;
        nextTick(() => {
            expressOrderingGrid.value.$el.scrollIntoView({ behavior: "smooth" });
        });
    };

    const builderData = ref({
        below_the_fold_cta: {
            label: null,
            scrollTarget: null,
            style: 'primary'
        },
        relatedProductLink: {
            label: null,
            seoName: null
        }
    })

    let observer;

    const belowTheFoldCta = computed(()=>{
        return builderData?.value?.belowTheFoldCta ?? {};
    })
    const belowTheFoldCtaTargetElement = ref(null);
    const showBelowTheFoldCta = computed(()=>{
        return belowTheFoldCta?.value?.label && belowTheFoldCtaTargetElement?.value;
    })
    const scrollToProductInfo = ()=>{
        belowTheFoldCtaTargetElement?.value?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest' 
        });
    };

    let settings = useSettingsStore();
    const { is_dealer, user_id, list, isLoggedIn, freeShippingAmount, canSeePricing, canPlaceOrders } = storeToRefs(settings);
    let buystackVisibleStore = useGenericStore('buyStackVisible', buyStackIsVisible.value);
    let expressVisibleStore = useGenericStore('expressVisible');
    const { setList, toggleFlyout, toggleBuystackFlyout } = settings;
    let { gtmViewItem, gtmAddToCartEvent } = useGoogleManager();
    
    onMounted(() => {
    
        if(props?.flash?.globalMessage?.open_flyout){
            nextTick(()=>{
                toggleFlyout();
            })
        }

        let buystackVisibilityCheck = useElementVisibility(buyStackRef);

        if(!hasPricingForProduct.value){
           getProductPricing();
        }
        watch(buystackVisibilityCheck, (value) => {
            buyStackIsVisible.value = value;

            buystackVisibleStore.set(value);
        });

        watch(express_ordering_open, (value) => {
            expressVisibleStore.set(value);
        });

        metaProductView({
            rothco_item_no: selectedVariant.value.rothcoItem.rothco_item_no,
            item_name: props.product.item_name,
            price: productPricing?.value?.price_to_use_with_discount
        })

        if(props.product.product_line_code){
            addViewedProduct(props.product.product_line_code);
        }

        observer = new MutationObserver((mutations) => {
            if(belowTheFoldCta.value.scrollTarget){
                const parsedUrl = new URL(belowTheFoldCta.value.scrollTarget);
                const selectedBlock = parsedUrl.searchParams.get("selectedBlock");
                if(selectedBlock){
                    const element = document.querySelector(`[builder-id="${selectedBlock}"]`) 
                        ? document.querySelector(`[builder-id="${selectedBlock}"]`) : document.querySelector(`[builder-id]`);
                    if(element){
                        belowTheFoldCtaTargetElement.value = element;
                        observer.disconnect();
                    }
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
        })

        try {
            const productCode = props.product.product_line_code;
            if (!productCode) return;
            IntelliSuggest.init({
                siteId: "xxkp6b",
                context: `Product/${productCode}`,
                seed: [`${productCode}`]
            });
            settings.setShopperId(user_id.value);

            IntelliSuggest.viewItem({ sku: `${productCode}` });

        } catch (e) {
            console.log(e);
        }
    });
    onBeforeUnmount(()=>{
        let chaportIntegration = document.getElementsByClassName('chaport-launcher-button');
        if (chaportIntegration.length > 0) {
            chaportIntegration[0].classList.remove('hidden');
        }
        expressVisibleStore.set(false);

        buyStackFlyoutDataState.value = {};
        settings.clearQuickViewProduct();

        if (observer) {
            observer.disconnect()
        }
    });

    let reviews = computed(() => props.product?.reviews?.all ?? []);

    provide("product_reviews", {
        reviews: reviews.value,
        itemId: props.product.item_index
    });

    let { inBasket } = useIntelliSuggest({
        siteId: "xxkp6b",
        shopperId: user_id.value ?? undefined,
    });



    let addToCart = function () {
        if(quantity.value <= 0 || +totalPrice.value == 0) return;
        const currentList = list.value;
        const variant = selectedVariant.value;
        const price = productPricing.value;
        const item = {
            source: import.meta.env.VITE_NORMAL_ORDERING_SOURCE,
            listId: currentList.list_id,
            current_unit_price: price?.price_to_use_with_discount,
            quantity: quantity.value,
            item_variation_id: variant.item_variation_id
        };
        

        addToList(item, {
            afterFetch: () => {
                inBasket({
                    items: [
                        {
                            sku: props.product.product_line_code,
                            qty: quantity.value,
                            price: price?.price_to_use_with_discount,
                        }
                    ]
                })
                gtmAddToCartEvent({
                    ...variant,
                    item: {
                        name: props.product.item_name,
                    },
                    price: price?.price_to_use_with_discount,
                    quantity: quantity.value,
                })
                if(!is_dealer.value){
                     attentiveAddToCart({
                        ...variant,
                        item: {
                            name: props.product.item_name,
                        },
                        price: price?.price_to_use_with_discount,
                        quantity: quantity.value,
                    })
                }
               
                return new Promise((resolve) => {
                    addCartProduct(props.product.product_line_code);
                    router.reload({
                        only: ["current_list", "last_added_item"],
                    onSuccess: (data) => {
                            setList(usePage().props.current_list);
                            resolve(data);
                            openCartPreview();
                            
                        }
                    });
                });
            }
        });

        
    };

    let openCartPreview = () => {
        const dialogRef = dialog.open(CartPreview, {
            props: {
                showHeader: false,
                modal: false
            }
        });

        setTimeout(() => {
            dialogRef.close();
        }, 9000);
    };

    let searchSpringCookiesStore = useSearchSpringCookiesStore();

    let { addViewedProduct, addCartProduct } = searchSpringCookiesStore;

    const favoritesStore = createUseFavoritesStore(`favorite-${props.product.item_index}`, {
        item_index: props.product.item_index, 
        user_id: user_id.value
    })();
    // console.log('favoritesStore', favoritesStore);
    let {favoriteId} = storeToRefs(favoritesStore);
    // let favoriteId = ref();
    const handleAccountLogin = () => {
        toggleFlyout({
            type: 'info',
            headline: 'Adding to Favorites? ',
            message: 'Please log in to save your favorite items.',
        });
    };

    const toggleFavorite = ()=>{
        if(!isLoggedIn.value) {
            handleAccountLogin();
            return;
        }
        hasFavorite.value ? favoritesStore.deleteFavorite() : favoritesStore.addFavorite();
    }

    let expressOrderingGrid = ref();
    
    const hasFavorite = computed(()=>{
        return ![0,null,'',undefined].includes(favoriteId.value)
    })

    let searchParams = computed(()=>({
        'data.seoName.$eq': props.product.seo_name
    }))
    let expressOrderingDefaultOpen = computed(()=>{
        return route().params.express == 1 && is_dealer.value;
    });

    let itemVariationCount = computed(()=>{
        return props.product.item_variations.length;
    });
    // let productLineCode = computed(()=>{
    //     return props.product.product_line_code;
    // });

    let productDetailStore = useProductDetailStore();
    let { productCode: productLineCode, categoryCodes} = storeToRefs(productDetailStore);
    productLineCode.value = props.product.product_line_code;
    let {response } = useBoost({
        product: productLineCode,
        limit: 1,
        shopperId: user_id.value ? user_id.value : undefined,
        tags: ['cross-sell'],
        filters: [],
    });


    let upsellProduct = computed(()=>{
        if(response.value.length == 0){
            return {
                item_id: null
            }
        }else if(response.value[0].results.length == 0){
            return {
                item_id: null
            }
        }
        let product = response.value[0].results?.[0];

        if(!product){
            return {
                item_id: null
            }
        }
        let variants = product.attributes.variants ? JSON.parse(he.decode(product.attributes.variants)).map(variant => JSON.parse(variant)) : []
        let colors = new Set();
        for(let i = 0; i < variants.length; i++){
            colors.add(variants[i].color);
        }
        return {
            category: product.attributes.category,
            item_id: product.id,
            item_name: product.mappings.core.name,
            item_price: product.mappings.core.price,
            item_image: product?.mappings?.core?.imageUrl ?? comingSoonImages().small,
            item_url: route('productDetail.show', [product.mappings.core.url]),
            seo_name: product.mappings.core.url,
            variants: product.attributes.variants ? JSON.parse(he.decode(product.attributes.variants)).map(variant => JSON.parse(variant)) : [],
            totalColors: colors.size
        }
    })

    function blurOnWheel(event) {
        event.target.blur();
    }
    let cms = ref();

    const pdpCmsHasBuilderContent = computed(()=>{
        return typeof cms.value?.hasBuilderContent == 'function' ? cms.value?.hasBuilderContent() : cms.value?.hasBuilderContent;
    })

    let categoriesComputed = computed(()=>{
        return [categories.value.map(category => category.category_name).join(">")];
    })

    let openBuyStackFlyout = () => {
        settings.toggleBuystackFlyout({seo_name: props.product.seo_name});
    };

    watch(() =>categoriesComputed, (newVal) => {
        categoryCodes.value = newVal.value;
    }, {
        immediate: true,
        deep: true
    })

    let customersAlsoBoughtCarousel = computed(()=>{
        return "Customers Also Bought";
    })

    let similarProductsCarousel = computed(()=>{
        return "Similar Products";
    });

    watch([express_ordering_open, pdpStickyVisible, buyStackFlyoutVisible], ([newVal, newVal2, newVal3]) => {
        let chaportIntegration = document.getElementsByClassName('chaport-launcher-button');

        if (newVal || newVal2 || newVal3) {
            if (chaportIntegration.length > 0) {
                chaportIntegration[0].classList.add('hidden');
            }
        }else{
            if (chaportIntegration.length > 0) {
                chaportIntegration[0].classList.remove('hidden');
            }
        }
    });

    const imageGalleryMobile = ref();
    watch(()=>(selectedVariantValues), (newVal)=>{
        imageGalleryMobile?.value?.backToStart();
    }, {deep: true})

    watch(selectedVariant , (newVal)=>{
       if(newVal?.item_variation_id){
            gtmViewItem({...
                newVal,
                item: {
                    name: props.product.item_name,
                },
                price: productPricing?.value?.price_to_use_with_discount,
                quantity: quantity.value,
            });
            if(!is_dealer.value){
                 attentiveProductView({
                    ...newVal,
                    item: {
                        name: props.product.item_name,
                    },
                    price: productPricing?.value?.price_to_use_with_discount,
                    quantity: quantity.value,
                })
            }
           
        }
    }, {deep: true, immediate: true});
</script>
